import "#legacy/embed/doctor_finder.js";

class EmbeddedProviderFinderBehavior extends Sparkle.PageBuilder.Components.Behavior {
  static {
    this.prototype.events = {
      "click [data-behaviour~='toggle-results']": "handleResultsToggleClick",
    };
  }

  constructor() {
    super(...arguments);
    this.onRender = this.onRender.bind(this);
    this.initialize = this.initialize.bind(this);
    this.configuration = this.configuration.bind(this);
    this.preset = this.preset.bind(this);
    this.configurationSearch = this.configurationSearch.bind(this);
    this.configurationResults = this.configurationResults.bind(this);
    this.configurationResult = this.configurationResult.bind(this);
    this.applyFadeIn = this.applyFadeIn.bind(this);
    this.updateEmbedLinkHref = this.updateEmbedLinkHref.bind(this);
    this.formatLink = this.formatLink.bind(this);
    this.initialScopes = this.initialScopes.bind(this);
    this.toggleShowMore = this.toggleShowMore.bind(this);
    this.sanitizeScope = this.sanitizeScope.bind(this);
  }

  onRender() {
    return this.initialize();
  }

  initialize() {
    super.initialize(...arguments);
    this.doctorFinderContainer = this.el.find(".sparkle-doctor-finder-container");
    const doctorFinderContainerId = this.doctorFinderContainer.attr("id");
    this.initialScopeParams = this.initialScopes();
    this.baseEmbedLinkHref = this.el.find("[data-doctor-finder-embed-link]").attr("href");
    this.applyFadeIn();
    this.updateEmbedLinkHref();

    return jQuery.when().then(() => new Sparkle.Embed.DoctorFinder(doctorFinderContainerId, this.configuration()));
  }

  // EVENT HANDLERS

  handleResultsToggleClick(event) {
    this.shouldShowMore = !this.shouldShowMore;
    return this.toggleShowMore($(event.currentTarget));
  }

  // HELPER FUNCTIONS

  configuration() {
    let landingPage;
    let rootPath;
    if (!this.doctorFinderContainer.data("doctor-finder-root-resource-index")) {
      rootPath = window.location.pathname;
      landingPage = { show: false }; // Hide the landing page in this component unless we are on the resource index for a location or physician.
    }

    const configuration = {
      rootPath,
      defaultSearch: {
        sort: this.doctorFinderContainer.data("doctor-finder-embed-config-sort"),
      },
      uuid: this.doctorFinderContainer.data("doctor-finder-embed-uuid"),
      openScheduling: this.doctorFinderContainer.data("doctor-finder-embed-config-open-scheduling-enabled"),
      search: this.configurationSearch(),
      ui: {
        preset: this.preset(),
        showFilters: this.doctorFinderContainer.data("doctor-finder-embed-config-show-filters"),
        landingPage,
        results: this.configurationResults(),
      },
    };

    return JSON.parse(JSON.stringify(configuration)); // Remove the undefined options
  }

  preset() {
    const directoryStyle = this.doctorFinderContainer.data("doctor-finder-embed-config-style");
    if (directoryStyle === "slider") {
      return "staticSlideshow";
    } else if (directoryStyle === "list") {
      return "staticList";
    } else if (directoryStyle === "basic") {
      return "finderCompact";
    } else {
      return "finderFull";
    }
  }

  configurationSearch() {
    const configuration = {
      specialty_scope: this.sanitizeScope(
        this.doctorFinderContainer.data("doctor-finder-embed-config-scoping-specialties"),
      ),
      location_scope: this.sanitizeScope(
        this.doctorFinderContainer.data("doctor-finder-embed-config-scoping-locations"),
        this.doctorFinderContainer.data("doctor-finder-embed-config-default-scoping-locations"),
      ),
      provider_type_scope: this.sanitizeScope(
        this.doctorFinderContainer.data("doctor-finder-embed-config-scoping-provider-types"),
      ),
      age_group_scope: this.sanitizeScope(
        this.doctorFinderContainer.data("doctor-finder-embed-config-scoping-age-groups"),
      ),
    };

    return JSON.parse(JSON.stringify(configuration)); // Remove the undefined options
  }

  configurationResults() {
    return {
      searchHeader: this.doctorFinderContainer.data("doctor-finder-embed-config-show-search-header"),
      pagination: this.doctorFinderContainer.data("doctor-finder-embed-config-show-pagination"),
      defaultPerPage: this.doctorFinderContainer.data("doctor-finder-embed-config-default-per-page"),
      maxResults: this.doctorFinderContainer.data("doctor-finder-embed-config-max-results"),
      showOnlyNextSlot: this.doctorFinderContainer.data("doctor-finder-embed-config-show-next-appointment"),
      stickyDateSelector: false,
      result: this.configurationResult(),
    };
  }

  configurationResult() {
    return {
      showProviderSpecialty: this.doctorFinderContainer.data("doctor-finder-embed-config-show-specialty"),
      showProviderAddress: this.doctorFinderContainer.data("doctor-finder-embed-config-show-address"),
      showProviderPhoneNumber: this.doctorFinderContainer.data("doctor-finder-embed-config-show-phone-number"),
      showProviderVisitType: this.doctorFinderContainer.data("doctor-finder-embed-config-show-visit-type"),
      showProviderAcceptingPatients: this.doctorFinderContainer.data(
        "doctor-finder-embed-config-show-accepting-patients",
      ),
      showProviderNotAcceptingPatients: this.doctorFinderContainer.data(
        "doctor-finder-embed-config-show-not-accepting-patients",
      ),
      showProviderRatings: this.doctorFinderContainer.data("doctor-finder-embed-config-show-ratings"),
      showProviderAgeGroup: this.doctorFinderContainer.data("doctor-finder-embed-config-show-age-group"),
      showProviderNextAppointment: this.doctorFinderContainer.data("doctor-finder-embed-config-show-next-appointment"),
    };
  }

  applyFadeIn() {
    this.resultsPreviewObserver?.disconnect();
    if (this.doctorFinderContainer.data("doctor-finder-embed-config-fade-in-results")) {
      this.doctorFinderContainer.addClass("sparkle-doctor-finder-fade-in-results");
      this.doctorFinderContainer.addClass("sparkle-doctor-finder-fade-in-results--active");
      // The finder renders its results after this runs, so each result view is put in preview as it appears.
      this.resultsPreviewObserver = new MutationObserver(() => this.syncResultsPreview());
      this.resultsPreviewObserver.observe(this.doctorFinderContainer[0], {
        childList: true,
        subtree: true,
      });
      this.syncResultsPreview();
    }
  }

  syncResultsPreview() {
    const preview = this.doctorFinderContainer.hasClass("sparkle-doctor-finder-fade-in-results--active");
    for (const resultView of this.doctorFinderContainer[0].querySelectorAll("sp-finder-result-view")) {
      resultView.toggleAttribute("preview", preview);
    }
  }

  updateEmbedLinkHref() {
    const linkElement = this.el.find("[data-doctor-finder-embed-link]");
    if (!linkElement.length) {
      return;
    }
    return linkElement.attr("href", this.formatLink());
  }

  formatLink() {
    const params = [this.initialScopeParams, new URL(window.location).searchParams].join("&");

    return this.baseEmbedLinkHref + "?" + params;
  }

  initialScopes() {
    const uuid = this.doctorFinderContainer.data("doctor-finder-embed-uuid");
    const scopeParams = uuid ? { uuid } : this.configurationSearch();

    return new URLSearchParams(scopeParams);
  }

  toggleShowMore($button) {
    const amount = this.shouldShowMore ? "Less" : "More";
    $button.text(`Show ${amount}`);
    this.doctorFinderContainer.toggleClass("sparkle-doctor-finder-fade-in-results--active", !this.shouldShowMore);
    return this.syncResultsPreview();
  }

  sanitizeScope(data, defaultScope = null) {
    if (!data) {
      return;
    }
    data = data.toString().split(",");
    data = data.map((datum) => {
      if (datum === "Automatic") {
        return defaultScope;
      } else {
        return datum;
      }
    });
    data = data.filter(Boolean); // Remove nulls
    if (data.length !== 0) {
      return data;
    }
  }
}
EmbeddedProviderFinderBehavior.register("embedded_provider_finder");
